import { Steps } from 'antd';
import React, { useState } from 'react';
import { COLORS } from '../../constants/colors';
import { Mode } from '../../types/AllTypes';
import LoadingButton from '../LoadingButton/LoadingButton';
import ModalBtnCotainer from '../ModalBtnContainer/ModalBtnContainer';
import OutLineButton from '../OutLineButton/OutLineButton';

// Internal Imports
import './ContentStepper.css';

// Interfaces
interface Props {
    steps: { title: string, content: JSX.Element }[];
    mode: Mode;
    method: () => void;
    canGoNext: boolean;
    canGoBack?: boolean;
    canSubmit: boolean;
    loadingSubmit: boolean;
}

const { Step } = Steps;

const ContentStepper = ({ steps, mode, method, canGoNext, canSubmit, loadingSubmit, canGoBack = true }: Props) => {

    // States
    const [current, setCurrent] = useState<number>(0);

    // Methods
    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    return (
        <div className="content_stepper">
            <Steps current={current}>
                {steps.map((item, index) => (
                    <Step key={item.title} title={`Paso ${index + 1}`} />
                ))}
            </Steps>
            <div className="stepper_title">{steps[current].title}</div>
            <div>{steps[current].content}</div>

            <ModalBtnCotainer style={{ justifyContent: current === 0 ? 'flex-end' : 'space-between' }}>
                {current > 0 && (
                    <OutLineButton
                        method={() => prev()}
                        disabled={!canGoBack}
                        text={<nav style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', alignItems: 'center' }}> <i className="fa-solid fa-arrow-left"></i> Anterior</nav>}
                        props={{ style: { padding: '3px', width: '150px', height: '32px' } }}
                        color={COLORS.blue_main(1)}
                    />
                )}

                {current < steps.length - 1 && (
                    <LoadingButton
                        type="button"
                        disabled={!canGoNext}
                        method={() => next()}
                        title={<nav style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', alignItems: 'center' }}>Siguiente <i className="fa-solid fa-arrow-right"></i></nav>}
                        loading={'false'}
                        background={COLORS.blue_main(1)}
                        color={COLORS.white_color1}
                        style={{ padding: '3px', width: '150px', height: '32px' }}
                        fontsize={16}
                    />

                )}
                {current === steps.length - 1 && (
                    <LoadingButton
                        type="button"
                        disabled={!canSubmit}
                        method={method}
                        title={mode === 'Add' || mode === 'Copy' ? "Guardar" : 'Modificar'}
                        loading={loadingSubmit.toString()}
                        background={COLORS.blue_active}
                        color={COLORS.white_color1}
                        style={{ padding: '3px', width: '150px', height: '32px' }}
                        fontsize={16}
                    />
                )}

            </ModalBtnCotainer>
        </div>
    );
}


export default ContentStepper;